<template>
    <div class="sliderMenu" v-loading='sliderLoading'>
        <el-row class="tac">
            <el-menu
                :default-active="currentActive"
                class="el-menu-vertical-demo"
                background-color="#545c64"
                text-color="#fff"
                active-text-color="#ffd04b"
                :default-openeds="defaultOpeneds"
                router
            >
                <el-submenu
                    
                    :index="String(index1)"
                    v-for="(item1, index1) in rowMenuList"
                    :key="index1"
                >
                    <template slot="title">
                        <span>{{item1.rowName}}</span>
                    </template>
                    <el-menu-item
                        :index="item2.router"
                        v-for="(item2, index2) in item1.childMenu"
                        :key="index2"
                    >{{item2.name}}</el-menu-item>
                </el-submenu>
            </el-menu>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            defaultOpeneds: [0],//当前打开的 sub-menu 的 index 的数组
            currentActive: '',//当前激活菜单的 index	
            rowMenuList: [],//当前侧边栏列表数据
            sliderLoading:true,
        }
    },
    props: [
        'menu'
    ],
    mounted() {
       
    },
    watch: {
        menu() {
            this.sliderLoading = false
            this.getSlider()
        }
    },
    methods: {
        getSlider() {
            // console.log(this.menu[0].rowLists)
            this.rowMenuList = this.menu[0].rowLists;
            //当前打开的 sub-menu 的 index 的数组
            let defaultOpeneds = [];
            this.rowMenuList.forEach((ele, index) => {
                defaultOpeneds.push(String(index))
            })
            this.defaultOpeneds = defaultOpeneds;
            //当前激活菜单的 index
            this.currentActive = this.rowMenuList[0].childMenu[0].router;
            this.currentActive = this.$route.path;
            $bus.$on('colMenuIndex', res => {
                this.rowMenuList = this.menu[res].rowLists;
                //当前打开的 sub-menu 的 index 的数组
                defaultOpeneds = [];
                this.rowMenuList.forEach((ele, index) => {
                    defaultOpeneds.push(String(index))
                })
                this.defaultOpeneds = defaultOpeneds;
                //当前激活菜单的 index
                this.currentActive = this.rowMenuList[0].childMenu[0].router;
                this.$forceUpdate();
            })
        }
    }
}
</script>

<style lang='scss'>
.sliderMenu {
    position: fixed;
    top: 70px;
    left: 0;
    height: 100%;
    width: 220px;
    overflow: hidden;
    background: #545c64;
    box-sizing: border-box;
    .tac {
        width: 220px;
        height: 100%;
        overflow: hidden;
        background: #545c64;
        ul,
        li {
            width: 100%;
        }
    }
}
</style>